import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormDialogTemplate } from '../../../../shared/form-dialog/form-dialog.template';
import { BehaviorSubject, Subject } from 'rxjs';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { DistributionCategoryService, DistributionMethodService } from '../../phf.service';
import { GroupDescriptor, SortDescriptor } from '@progress/kendo-data-query';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service'


@Component({
  selector: 'distribution-method',
  templateUrl: './distribution-method.component.html'
})
export class DistributionMethodComponent extends DataGridTemplate implements OnInit {
  editForm: FormGroup;
  addDistributionCategoryEditForm: FormGroup;
  editDistributionCategoryEditForm: FormGroup;
  deleteDistributionCategoryEditForm: FormGroup;
  formDialog: FormDialogTemplate;
  dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  categories: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(undefined);
  distributionMethods: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(undefined);
  groups: GroupDescriptor[];
  sorts: SortDescriptor[];
  addDistributionCategoryFormDialog: FormDialogTemplate;
  editDistributionCategoryFormDialog: FormDialogTemplate;
  deleteDistributionCategoryFormDialog: FormDialogTemplate;
  private readonly distributeCategoryLabel = "Distribution Category";
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly alertDialog: CgpAlertDialogService,
    private readonly distributionMethodService: DistributionMethodService,
    private readonly distributionCategoryService: DistributionCategoryService,
    private readonly cgpSnackbarService: CgpSnackbarService,
  ) {
    super();
  }

  ngOnInit() {
    this.httpErrorHeader = "Distribution Method Error";
    this.groupable = true;
    this.groups = [{ field: 'DistributionCategoryName' }];
    this.gridState.group = this.groups;
    this.formDialog = new FormDialogTemplate();
    this.addDistributionCategoryFormDialog = new FormDialogTemplate();
    this.editDistributionCategoryFormDialog = new FormDialogTemplate();
    this.deleteDistributionCategoryFormDialog = new FormDialogTemplate();
    this.deleteDistributionCategoryFormDialog.customTitle = "Delete";
    this.modal = true;
    this.formDialog.setHeight(480);
    this.controls.excel = true;
    this.editForm = this.formBuilder.group({
      Id: [],
      Name: [],
      DistributionCategoryId: ['', Validators.required],
      Description: ['', Validators.required],
      DisplayDistributionCategory: []
    });
    this.addDistributionCategoryEditForm = this.formBuilder.group({
      Id: [],
      Name: ['', Validators.required],
    })
    this.editDistributionCategoryEditForm = this.formBuilder.group({
      Id: ['', Validators.required],
      Name: ['', Validators.required],
    })
    this.deleteDistributionCategoryEditForm = this.formBuilder.group({
      Id: ['', Validators.required],
      Name: [],
    })

    this.controls.customToolBarButtons = [
      {
        id: 'distributionCategory',
        title: 'Add new Distribution Category',
        text: 'Add new Distribution Category',
        callback: this.handleAddDistributionCategory,
      },
      {
        id: 'editDistributionCategory',
        title: 'Edit Distribution Category',
        text: 'Edit Distribution Category',
        callback: this.handleEditDistributionCategory,
      },
      {
        id: 'deletedistributionCategory',
        title: 'Delete Distribution Category',
        text: 'Delete Distribution Category',
        callback: this.handleDeleteDistributionCategory,
      },
    ]
    this.formDialog.initilize(this.dialogTitle, this.editForm, this.formDialogTabs);
    this.dialogTitle.next('Distribution Method');
    this.addDistributionCategoryFormDialog.initilize(this.distributeCategoryLabel, this.addDistributionCategoryEditForm, this.addDistributionCategoryTabs);
    this.editDistributionCategoryFormDialog.initilize(this.distributeCategoryLabel, this.editDistributionCategoryEditForm, this.editDistributionCategoryTabs);
    this.deleteDistributionCategoryFormDialog.initilize(this.distributeCategoryLabel, this.deleteDistributionCategoryEditForm, this.deleteDistributionCategoryTabs);
    this.deleteDistributionCategoryFormDialog.setSubmitButtonText('Submit');
  }

  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.dialogTitle.complete();
  }

  read(opts: any): Promise<any> {
    if (opts.force) {
      return this.distributionMethodService.read()
        .then(response => {
          this.distributionCategoryService.read()
            .then(categories => {
              response = response.map(valueToBeMapped => {
                const match = categories.find(c => c.Id === valueToBeMapped.DistributionCategoryId);
                if (match) valueToBeMapped.DisplayDistributionCategory = match.Name;
                return valueToBeMapped;
              })
            })
          return response;
        })
    }
    else {
      return Promise.resolve(this.distributionMethodService.value);
    }
  }

  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.formDialog.next({});
  }


  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.formDialog.next(dataItem);
  }

  save(dataItem: any, isNew: boolean): Promise<any> {
    return isNew ?
      this.distributionMethodService.save(dataItem, isNew, "")
      : this.distributionMethodService.save(dataItem, isNew, "/" + dataItem.Id);
  }

  delete(dataItem: any): Promise<any> {
    return this.distributionMethodService.remove('/' + dataItem.Id);
  }

  handleAddDistributionCategory = () => {
    this.addDistributionCategoryFormDialog.isNew = true;
    this.addDistributionCategoryFormDialog.next(true);
  }

  handleEditDistributionCategory = () => {
    this.editDistributionCategoryEditForm.get('Name').disable();
    this.editDistributionCategoryFormDialog.isNew = false;
    this.editDistributionCategoryFormDialog.next(true);
  }

  handleDeleteDistributionCategory = () => {
    this.deleteDistributionCategoryFormDialog.isNew = false;
    this.deleteDistributionCategoryFormDialog.next(true);
  }

  onAddDistributionCategory = (e: any) => {
    this.distributionCategoryService.save(e.dataItem, true, "")
      .then(x => {
        this.refresh();
        this.cgpSnackbarService.showSnackbar({
          message: `New Distribution Category was created`,
          duration: 2000
        })
      })
  }

  onEditDistributionCategory = (e: any) => {
    this.distributionCategoryService.save(e.dataItem, false, `/${e.dataItem.Id}`)
      .then(x => {
        this.refresh();
        this.cgpSnackbarService.showSnackbar({
          message: `Distribution Category was edited.`,
          duration: 2000
        })
      })
  }

  onDeleteDistributionCategory = (e: any) => {
    this.distributionCategoryService.remove(`?id=${e.dataItem.Id}`)
      .then(x => {
        this.refresh();
        this.cgpSnackbarService.showSnackbar({
          message: `Distribution Category was deleted`,
          duration: 2000
        })
      })
  }

  handleSelectionOnEditingDistributionCategory = (e: any) => {
    const controls = this.editDistributionCategoryEditForm.controls;
    if (controls['Id'].value == null) {
      this.editDistributionCategoryEditForm.get('Name').setValue(null);
    }
    else {
      this.editDistributionCategoryEditForm.get('Name').enable();
    }
  }



  columns: any[] = [
    {
      field: 'DistributionCategoryName',
      title: 'Category',
      sortable: false,
    },
    {
      field: 'Description',
      title: 'Description',
      width: '*',
      sortable: false,
    },
  ]
  formControls = [
    {
      name: "DistributionCategoryId",
      service: this.distributionCategoryService,
      title: "Category",
      type: "combobox",
      textField: "Name",
      valueField: "Id",
      stretch: true,
    },
    {
      type: "textarea",
      name: "Description",
      title: "Description",
      stretch: true,
    },
  ]

  addDistributionCategoryFormControls = [
    {
      type: "text",
      name: "Name",
      title: "Name",
      stretch: true,
    },
  ]

  editDistributionCategoryFormControls = [
    {
      type: "combobox",
      name: "Id",
      title: "Select Distribution Category",
      textField: "Name",
      valueField: "Id",
      service: this.distributionCategoryService,
      onChange: this.handleSelectionOnEditingDistributionCategory,
      filterable: false,
      stretch: true,
    },
    {
      type: "text",
      name: "Name",
      title: "New Name",
      stretch: true,
    }
  ]

  deleteDistributionCategoryFormControls = [
    {
      type: "combobox",
      name: "Id",
      title: "Name",
      textField: "Name",
      valueField: "Id",
      service: this.distributionCategoryService,
      stretch: true,
    },
  ]

  formDialogTabs = [
    {
      title: "Distribution Method",
      selected: true,
      formControls: this.formControls
    },
  ]

  addDistributionCategoryTabs = [
    {
      title: this.distributeCategoryLabel,
      selected: true,
      formControls: this.addDistributionCategoryFormControls
    },
  ]

  editDistributionCategoryTabs = [
    {
      title: this.distributeCategoryLabel,
      selected: true,
      formControls: this.editDistributionCategoryFormControls
    },
  ]

  deleteDistributionCategoryTabs = [
    {
      title: this.distributeCategoryLabel,
      selected: true,
      formControls: this.deleteDistributionCategoryFormControls
    },
  ]

  distributionCategoryTabs = [
    {
      title: "Add",
      selected: true,
      formControls: this.addDistributionCategoryFormControls
    },
    {
      title: "Edit",
      formControls: this.editDistributionCategoryFormControls
    },
    {
      title: "Delete",
      formControls: this.deleteDistributionCategoryFormControls
    },
  ]

}
